import { Button } from '@/shared/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/shared/components/ui/dialog';
import React from 'react';

interface DrugInfoUpdateConfirmModalProps {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

export const DrugInfoUpdateConfirmModal: React.FC<
  DrugInfoUpdateConfirmModalProps
> = ({ open, onClose, onConfirm }) => (
  <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
    <DialogContent className="max-w-sm">
      <DialogHeader className="text-center">
        <DialogTitle className="text-base font-semibold leading-snug">
          의약품 정보를
          <br />
          업데이트합니다.
        </DialogTitle>
      </DialogHeader>
      <DialogFooter className="justify-center gap-2 sm:justify-center">
        <Button variant="outline" onClick={onClose}>
          취소
        </Button>
        <Button
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          업데이트
        </Button>
      </DialogFooter>
    </DialogContent>
  </Dialog>
);
